import React from "react";
import { SearchDoctors } from "./pages/Doctors/SearchDoctors/SearchDoctors";
import { DoctorsSearchResults } from "./pages/Doctors/DoctorsSearchResults/DoctorsSearchResults";
import { GlobalSearchResults } from "./pages/globalSearchResults/GlobalSearchResults";
import { pages } from "assets/constants";
import { DoctorsInBranch } from "pages/Doctors/DoctorsInBranch/DoctorsInBranch";
import { SearchMedicalCenters } from "pages/MedicalCenters/SearchMedicalCenters/SearchMedicalCenters";
import { MedicalCenterSearchResults } from "pages/MedicalCenters/MedicalCentersSearchResults/MedicalCentersSearchResults";
import { OuterServicesSearchResults } from "pages/OuterServices/OuterServicesSearchResults/OuterServicesSearchResults";
import { SearchOuterServices } from "pages/OuterServices/SearchOuterServices/SearchOuterServices";
import { SearchShaban } from "pages/Shaban/SearchShaban/SearchShaban";
import { ShabanSearchResults } from "pages/Shaban/ShabanSearchResults/ShabanSearchResults";
import { MedicinesSearchResults } from "pages/MedicinesSearchResults/MedicinesSearchResults";
import { EntitlementSearchResults } from "pages/EntitlementSearchResults/EntitlementSearchResults";
import { EntitlementFieldLobbyResults } from "pages/EntitlementFieldLobby/EntitlementFieldLobbyResults";
import { GlobalSearchResultsAutoSuggest } from "pages/globalSearchResultsAutoSuggest/GlobalSearchResultsAutoSuggest";

export const App = (props: any) => {
  if (props.pageName === pages.globalSearchResults) {
    return <GlobalSearchResults />;
  } else if (props.pageName === pages.doctorsInBranch) {
    return <DoctorsInBranch />;
  } else if (props.pageName === pages.searchDoctors) {
    return <SearchDoctors objectType={1}/>;
  } else if (props.pageName === pages.doctorsSearchResults) {
    return <DoctorsSearchResults objectType={1}/>;
  } else if (props.pageName === pages.searchDiet) {
    return <SearchDoctors objectType={2}/>;
  } else if (props.pageName === pages.dietSerachResults) {
    return <DoctorsSearchResults objectType={2}/>;
  } else if (props.pageName === pages.searchSocialWorker) {
    return <SearchDoctors objectType={3}/>;
  } else if (props.pageName === pages.socialWorkerSearchResults) {
    return <DoctorsSearchResults objectType={3}/>;
  } else if (props.pageName === pages.searchMedicalCenters) {
    return <SearchMedicalCenters objectType={4} />;
  } else if (props.pageName === pages.medicalCentersSearchResults) {
    return <MedicalCenterSearchResults objectType={4} />;
  } else if (props.pageName === pages.searchEmergency) {
    return <SearchMedicalCenters objectType={6} />;
  } else if (props.pageName === pages.emergencySearchResults) {
    return <MedicalCenterSearchResults objectType={6} />;
//    return <EmergencySearchResults />;
  } else if (props.pageName === pages.searchOptica) {
    return <SearchMedicalCenters objectType={5} />;
  } else if (props.pageName === pages.opticaSearchResults) {
    //return <OpticaSearchResults />;
    return <MedicalCenterSearchResults objectType={5} />;
  } else if (props.pageName === pages.searchPharmacy) {
    return <SearchMedicalCenters objectType={7} />;
  } else if (props.pageName === pages.pharmacySearchResults) {
    //return <PharmacySearchResults />;
    return <MedicalCenterSearchResults objectType={7} />;
  } else if (props.pageName === pages.searchWomenEmergency) {
    return <SearchMedicalCenters objectType={8} />;
  } else if (props.pageName === pages.womenEmergencySearchResults) {
    return <MedicalCenterSearchResults objectType={8} />;
    //return <PharmacySearchResults />;
  } else if (props.pageName === pages.searchTeeth) {
    return <SearchMedicalCenters objectType={9} />;
  } else if (props.pageName === pages.teethSearchResults) {
    //return <PharmacySearchResults />;
    return <MedicalCenterSearchResults objectType={9} />;
  } else if (props.pageName === pages.searchOuterService) {
    return <SearchOuterServices objectType={10} />;
  } else if (props.pageName === pages.outerServiceSearchResults) {
    return <OuterServicesSearchResults />;
  } else if (props.pageName === pages.searchOperations) {
    return <SearchShaban />;
  } else if (props.pageName === pages.operationsSearchResults) {
    return <ShabanSearchResults />;
  } else if (props.pageName === pages.medicinesPage) {
    return <MedicinesSearchResults />;
  } 
  else if (props.pageName === pages.entitlementPage) {
    return <EntitlementSearchResults />;
  } 
  else if (props.pageName === pages.entitlementFieldLobby) {
    return <EntitlementFieldLobbyResults />;
  }
  else if (props.pageName === pages.globalSearchResultsAutoSuggest) {
    return <GlobalSearchResultsAutoSuggest />;
  }
  return null;
};
